import { QueryConfig, useQuery } from "react-query";
import { getAccountCustomer } from "../services";

export const useAccountCustomer = (
  accountNumber: string,
  options?: Partial<QueryConfig<any>>,
) => {
  return useQuery(["accounts/customer", accountNumber], getAccountCustomer, {
    ...(options || {}),
    enabled: !!accountNumber,
  });
};
